import * as React from 'react';
import { AnimatePresence, AnimatePresenceProps } from 'framer-motion';

export interface IAnimationLayoutProps extends AnimatePresenceProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

export const AnimationLayout = ({ initial = false, mode = 'wait', children, ...animation }: IAnimationLayoutProps) => (
  <AnimatePresence initial={initial} mode={mode} {...animation}>
    {children}
  </AnimatePresence>
);
